var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createRef, useCallback, useEffect, useState, useMemo, } from 'react';
var AsyncImage = React.memo(function (props) {
    var srcLoaded = props.srcLoaded, srcLoading = props.srcLoading, src = props.src, alt = props.alt, className = props.className;
    var _a = useState(null), loadedSrc = _a[0], setLoadedSrc = _a[1];
    useEffect(function () {
        setLoadedSrc(null);
        if (src) {
            var handleLoad_1 = function () {
                setLoadedSrc(src);
            };
            var image_1 = new Image();
            image_1.addEventListener('load', handleLoad_1);
            image_1.src = src;
            return function () {
                image_1.removeEventListener('load', handleLoad_1);
            };
        }
        return;
    }, [src]);
    if (loadedSrc === src) {
        srcLoaded(null);
        return (_jsx("img", { className: className, src: src, alt: alt }));
    }
    srcLoading();
    return (_jsx("div", __assign({ className: "painting__image" }, { children: _jsx("div", __assign({ className: "flx-ctr fadein image__loading" }, { children: _jsx("svg", __assign({ className: "loading", viewBox: "25 25 50 50" }, { children: _jsx("circle", { cx: "50", cy: "50", r: "20" }) })) })) })));
});
export default React.memo(function (props) {
    var paintings = props.paintings, cityName = props.cityName, page = props.page, setPage = props.setPage;
    var _a = useState(1), seed = _a[0], setSeed = _a[1];
    var labelRef = createRef();
    var timeouts = useMemo(function () { return []; }, []);
    function getWidth() {
        return "height=".concat(Math.round(window.innerHeight * 1.2), "&width=").concat(window.innerWidth < 632
            ? Math.round(window.innerWidth * 0.56)
            : Math.round(window.innerWidth * 0.9));
    }
    var cancelReload = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var i;
        return __generator(this, function (_a) {
            for (i = timeouts.length; i--;) {
                clearTimeout(timeouts[i]);
                timeouts.pop();
            }
            return [2 /*return*/];
        });
    }); }, [timeouts]);
    var reset = function () {
        setSeed(Math.random());
    };
    var reloadImg = function () {
        cancelReload();
        reset();
    };
    function srcLoading() {
        timeouts.length < 1 && timeouts.push(setTimeout(reloadImg, 2500));
    }
    function srcLoaded() {
        labelRef.current &&
            labelRef.current.scrollIntoView({ behavior: 'smooth' });
        cancelReload();
    }
    useEffect(function () { return function () {
        timeouts.length > 0 && cancelReload();
    }; }, [cancelReload, timeouts.length]);
    return (_jsx("div", __assign({ className: "painting__frame flx-ctr" }, { children: paintings &&
            paintings.length > 0 &&
            paintings[page] &&
            cityName !== '' ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ ref: labelRef, className: "painting__heading" }, { children: paintings[page].title })), _jsx("div", { className: "break" }), _jsx("div", __assign({ className: "frame__cell left " }, { children: _jsx(AsyncImage, { className: "left painting__image", srcLoading: srcLoading, srcLoaded: srcLoaded, src: "".concat(paintings[page].primaryimageurl, "?").concat(getWidth()), alt: "image of ".concat(paintings[page].title) }, seed) })), _jsxs("div", __assign({ className: "frame__cell right" }, { children: [_jsxs("div", __assign({ className: "painting__label" }, { children: [_jsx("span", __assign({ className: "label__title row" }, { children: paintings[page].title })), paintings[page].people &&
                                    paintings[page].people.length > 0 && (_jsx("span", __assign({ className: "label__artist row" }, { children: paintings[page].people[0].name }))), _jsx("span", __assign({ className: "label__region row green" }, { children: cityName })), _jsx("span", __assign({ className: "label__dated row" }, { children: paintings[page].dated })), _jsx("span", __assign({ className: "label__period row" }, { children: paintings[page].period })), _jsx("span", __assign({ className: "label__medium row" }, { children: paintings[page].medium }))] })), _jsxs("div", __assign({ className: "painting__paging page" }, { children: [page + 1, " of ", paintings.length, _jsx("br", {}), _jsx("button", __assign({ type: "button", className: "prev", onClick: function () { return setPage(page - 1); }, disabled: page === 0 }, { children: "previous" })), ' ', "|", ' ', _jsx("button", __assign({ type: "button", className: "next", onClick: function () { return setPage(page + 1); }, disabled: page === paintings.length - 1 }, { children: "next" }))] }))] }))] })) : (_jsx("div", __assign({ className: "render-coontainer" }, { children: _jsx("div", __assign({ className: "painting flx-ctr fadein" }, { children: _jsx("svg", __assign({ className: "loading", viewBox: "25 25 50 50" }, { children: _jsx("circle", { cx: "50", cy: "50", r: "20" }) })) })) }))) })));
});
